import assessmentActions from '../actions/AssessmentActions';
import { reportError } from '../services/ErrorReporting';

/**
 * The sections array is replaced by a new one using map and for each section, the questions array is replaced adding the
 * parsed question
 * @param sections
 * @param action
 * @returns [sections]
 */
const replaceQuestionInSections = (sections, action) => {
    return sections.map((section) => {
        const questions = section.questions.map((question) => {
            return question.contentRevisionId === action.id ? action.questionModel : question;
        });

        return Object.assign({}, section, { questions });
    });
};

const replaceStimulus = (sections, action) => {
    return sections.map((section) => {
        if (section.stimulusContent && action.id === section.stimulusContent.contentRevisionId) {
            return Object.assign({}, section, { stimulusContent: action.questionModel });
        }

        return section;
    });
};

const setAllQuestionsAsNotParsed = (sections) => {
    return sections.map((section) => {
        const questions = section.questions.map(question => ({ ...question, ...{ isParsed: false } }));
        return Object.assign({}, section, { questions });
    });
};

export default function (state = {}, action) {
    const documentParseError = action.questionModel ? action.questionModel.documentParseError : false;

    switch (action.type) {
    case assessmentActions.types.ASSESSMENT_SET_STATE:
        // when the assessment has been loaded, the whole assessment state should be replaced with the response json
        return Object.assign({}, action.assessment);

    case assessmentActions.types.ASSESSMENT_STIMULUS_PARSED:
        // use map to replace the question parsed in the questions array
        if (documentParseError) {
            reportError(documentParseError);
        }

        return Object.assign({}, state, {
            sections: replaceStimulus(state.sections, action),
        });

    case assessmentActions.types.ASSESSMENT_QUESTION_PARSED:
        // use map to replace the question parsed in the questions array
        if (documentParseError) {
            reportError(documentParseError);
        }

        return Object.assign({}, state, {
            sections: replaceQuestionInSections(state.sections, action),
        });

    case assessmentActions.types.ASSESSMENT_SKETCH_CODES_LOADED:
        return Object.assign({}, state, action);

    case assessmentActions.types.ASSESSMENT_SKETCH_CODE_LOADED:
        return Object.assign({}, state, {
            sketchCodes: Object.assign({}, state.sketchCodes, action.sketchCode),
        });

    case assessmentActions.types.ASSESSMENT_FEEDBACK_LOADED:
        return Object.assign({}, state, {
            feedbacks: Object.assign({}, state.feedbacks, action.feedbacks),
        });

    case assessmentActions.types.ASSESSMENT_FEEDBACK_RESET:
        delete state.feedbacks;
        return Object.assign({}, state);

    case assessmentActions.types.ASSESSMENT_QUESTIONS_RESET_PARSED:
        return Object.assign({}, state, {
            sections: setAllQuestionsAsNotParsed(state.sections),
        });

    default:
        return state;
    }
}
